import React from 'react';
import { Link } from 'react-router-dom';
import brascoCommunicationsLogo from '../assets/AppImages/Brasco Communications Logo.jpg';

function Footer() {
  const externalLinkProps = {
    target: '_blank',
    rel: 'noopener noreferrer',
  };

  return (
    <footer className="site-footer">
      <div className="mx-auto max-w-7xl px-8 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/home" className="inline-flex no-underline">
              <img src="/royalty-logo-dark.jpeg" alt="DeRoyalty Car Rental" className="site-footer-logo h-[95px] w-auto" />
            </Link>
            <p className="mt-3 text-primary-theme">Follow us on our Social platforms</p>
            <div className="mt-4 flex flex-wrap gap-5">
              <a href="https://www.instagram.com/royaltycarsrental" className="media-icon bi bi-instagram" aria-label="Instagram" />
              <a href="https://linkedin.com/" className="media-icon bi bi-linkedin" aria-label="LinkedIn" />
              <a href="https://twitter.com/" className="media-icon bi bi-twitter" aria-label="Twitter" />
              <a href="https://facebook.com/" className="media-icon bi bi-facebook" aria-label="Facebook" />
              <a href="https://youtube.com/" className="media-icon bi bi-youtube" aria-label="YouTube" />
            </div>
          </div>

          <div className="lg:col-span-2">
            <h3 className="footer-heading mb-4 text-primary-theme">Get to know us</h3>
            <ul className="space-y-3 p-0 list-none">
              <li><Link to="/about" className="footer-link">About</Link></li>
              <li><Link to="/meet-the-team" className="footer-link">Meet the Team</Link></li>
              <li><a href="#ios-app" className="footer-link">IOS App</a></li>
              <li><a href="#learn-more" className="footer-link">Learn More</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="footer-heading mb-4 text-primary-theme">Quick Links</h3>
            <ul className="space-y-3 p-0 list-none">
              <li><Link to="/home" className="footer-link">Home</Link></li>
              <li><Link to="/vehicles" className="footer-link">Vehicles</Link></li>
              <li><Link to="/lease-your-vehicle" className="footer-link">Lease Your Vehicle</Link></li>
              <li><a href="#faq" className="footer-link">FAQ</a></li>
              <li><a href="#service" className="footer-link">Service</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="footer-heading mb-4 text-primary-theme">Legal</h3>
            <ul className="space-y-3 p-0 list-none">
              <li><Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link></li>
              <li><a href="#privacy-policy" className="footer-link">Privacy Policy</a></li>
              <li><a href="#feedback" className="footer-link">Feedback</a></li>
              <li><a href="#cookie-policy" className="footer-link">Cookie Policy</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="footer-heading mb-4 text-primary-theme">Contact Us</h3>
            <address className="not-italic leading-7 text-primary-theme">
              2870 Mainway Meadows<br />
              Waterfalls, Harare<br />
              <a href="tel:+263712768037" className="footer-link">+263712768037</a>
            </address>
          </div>
        </div>
      </div>

      <div className="footer-credit-strip" aria-label="Website credits">
        <div className="footer-credit-inner">
          <a
            href="https://webdizajn-beograd.com/services/seo-website-optimization"
            className="footer-credit-mark"
            {...externalLinkProps}
          >
            <img src={brascoCommunicationsLogo} alt="Brasco Communications" />
          </a>

          <nav className="footer-credit-links" aria-label="Footer credit links">
            <a href="https://webdizajn-beograd.com/en" {...externalLinkProps}>Web Design</a>
            <span aria-hidden="true">|</span>
            <a href="https://www.royalcarrentalgroup.com/blog" {...externalLinkProps}>Blog</a>
            <span aria-hidden="true">|</span>
            <a href="https://webdizajn-beograd.com/services/seo-website-optimization" {...externalLinkProps}>
              Website Development by BRASCO COMMUNICATIONS
            </a>
          </nav>

          <div className="footer-credit-copy">
            <span>Copyright &copy; 2026</span>
            <span aria-hidden="true">|</span>
            <a href="https://webdizajn-beograd.com/services/improve-your-websites-google-rank" {...externalLinkProps}>
              SEO optimization by Brasco Communications
            </a>
            <span aria-hidden="true">|</span>
            <a href="https://www.royalcarrentalgroup.com/" {...externalLinkProps}>Deroyalty Car Rental</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
